import TopBar from './TopBar/TopBar.jsx'
export default function MainReactContent() {
    console.log("hello from main content")
    return (
        <>
            <div className="overscroll-y-none bg-transparent flex items-start justify-center min-h-svh min-w-svw text-white pointer-events-auto sm:pointer-events-none">
                <div className="mt-[20vh] sm:mt-[30.33vh] rounded-sm w-[92svw] sm:max-w-2xl mx-3 mb-5">
                    <h1 className="text-center text-4xl mb-8">
                        <span className="inline-block animate-wave mr-1 transform-gpu">👋</span>
                        Hi, <span className="text-white font-bold inline-block hover:text-sky-300 transition duration-200 cursor-default pointer-events-auto select-none">Shree</span> here!
                    </h1>
                    <TopBar />
                </div>
            </div>
        </>
    )
}
